export default [
    {//首页
        path: '/',
        redirect: "/square",
        component: function (resolve) {
            require(['./Layout.vue'], resolve);
        },
        children: [
            {
                path: '/square',
                meta: {keep: true},
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
            {
                path: '/mj',
                meta: {keep: true},
                component: function (resolve) {
                    require(['./mj.vue'], resolve);
                }
            },
            {
                path: '/favorites',
                meta: {keep: true},
                component: function (resolve) {
                    require(['./favorites.vue'], resolve);
                }
            },
            {
                path: '/member',
                // meta: {keep: true},
                redirect: '/'
            },
            {
                path: '/tuiguang',
                name: 'index_ad',
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
            {
                path: '/zz360tg',
                name: 'zz360tg',
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
            {
                path: '/tg:tg',// 推广
                name: 'tg',// 推广
                alias: '/tg:tg/', // 兼容带斜杠的访问
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
            {
                path: '/sd',
                meta: {keep: true},
                component: function (resolve) {
                    require(['./sd.vue'], resolve);
                }
            },
            // {
            //     path: '/nezha',
            //     meta: {keep: true},
            //     component: function (resolve) {
            //         require(['./nezhaTool.vue'], resolve);
            //     }
            // },
            {
                path: '/dallE3',
                meta: {keep: true},
                component: function (resolve) {
                    require(['./dallE3.vue'], resolve);
                }
            },
            {
                path: '/aiTool',
                component: function (resolve) {
                    require(['./aiTool.vue'], resolve);
                },
            },
            {
                path: '/aiBeautify',
                component: function (resolve) {
                    require(['./aiBeautify.vue'], resolve);
                },
            },
            {
                path: '/workflow',
                component: function (resolve) {
                    require(['./aiToolChild.vue'], resolve);
                },
            },
            {
                path: '/mj2',
                meta: {keep: true},
                component: function (resolve) {
                    require(['./mj4_25.vue'], resolve);
                }
            },
            {
                path: '/sd2',
                meta: {keep: true},
                component: function (resolve) {
                    require(['./sd4_25.vue'], resolve);
                }
            },

        ]
    },
    {//联系我们
        path: '/contact',
        component: function (resolve) {
            require(['./contact.vue'], resolve);
        },
    },
    {// 广告绘画详情
        path: '/drawDetail',
        component: function (resolve) {
            require(['./drawDetail.vue'], resolve);
        },
    },
    {// 会员绘画详情
        path: '/mydrawDetail',
        component: function (resolve) {
            require(['./userDrawDetail.vue'], resolve);
        },

    },
    {// home
        path: '/home',
        component: function (resolve) {
            require(['./home.vue'], resolve);
        },
    },
    {// promotion
        path: '/promotion',
        component: function (resolve) {
            require(['./promotion.vue'], resolve);
        },
    },
    {
        // 退款
        path:"/reqrefund",
        name:"reqrefund",
        component:() => import('VIEWS/Reqrefund.vue')
    },
]